<template>
  <Responsive
    :breakpoints="{
      small: el => el.width <= 480,
    }"
  >
    <div
      class="px-4 scrollable-container"
      slot-scope="el"
      @click.prevent.stop="$store.myActions.UI_SET_MEASURETOOL('NONE')"
    >
      <div style="overflow: auto; height: 100%">
        <div style="width: calc(100% - 20px)">
          <template v-for="menuItemGroup in menuItemsGroups">
            <v-layout py-2 row wrap align-content-start :key="menuItemGroup.key">
              <v-flex
                class="px-2"
                :class="{ sm12: el.is.small, sm6: !el.is.small }"
                xs12
                v-for="menuitem in menuItemGroup.values"
                :key="menuitem.cmp"
              >
                <v-btn
                  color="primary"
                  :disabled="
                    !missionSecurity[menuitem.securityKey].enable ||
                    (menuitem.mustBeActive && !currentDetailMission.mission.misActifOn)
                  "
                  :input-value="tabCreated(menuitem.cmp)"
                  class="menu-btn"
                  outline
                  @click="$store.myActions.MISSION_NAVTO_DETAIL({ cmp: menuitem.cmp, isleft, id: -1 })"
                >
                  <v-icon v-if="menuitem.icon" left v-html="menuitem.icon"></v-icon>
                  {{ tryTranslate(menuitem.label) }}
                  <v-spacer />
                  <template v-if="menuitem.iris && (!menuitem.mustBeActive || currentDetailMission.mission.misActifOn)">
                    <v-icon color="green" v-if="moduleIrisState[menuitem.irisModule]">mdi-check</v-icon>
                  </template>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-divider :key="`hr_${menuItemGroup.key}`" />
          </template>
        </div>
      </div>
    </div>
  </Responsive>
</template>
<script>
import { MISSIONS_DETAIL_TABS } from '@/models/ui/MissionTabs'
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { groupBy } from '@/utils/groupBy'
import { mapGetters } from 'vuex'

export default {
  name: 'MissionMenu',
  props: {
    isleft: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'currentDetailMission',
      'originalAd2cpConfigs',
      'originalNsdConfigs',
      'originalSingleWayPointConfigs',
      'originalMissionPlanConfigs',
      'originalSendMailConfigs',
      'originalFileTransfertConfigs',
      'originalCoriolisConfigs',
      'originalFtpConfigs',
      'originalRsyncConfigs',
      'originalAisConfigs',
      'originalQuickControlConfigs',
    ]),
    menuItemsGroups() {
      return groupBy(
        MISSIONS_DETAIL_TABS.filter(m => {
          if (!this.missionSecurity[m.securityKey].visible) return false
          if (m.cmp === 'MissionDetailEncryption' && !this.currentDetailMission.mission.isGeoHidden) return false
          // BLF037 — rien de la flotte si elle est refusée pour son enseigne (RG-ACC-053)
          if (m.securityKey === SecurityItemsKeys.PILOT_DETAIL_FLEET_MANAGEMENT) {
            const fleId = this.currentDetailMission.mission.fleId
            if (!fleId || !this.$store.getters.isFleetAllowed(this.$store.getters.adminFleetsById[fleId])) return false
          }
          return true
        }),
        m => m.group,
      )
    },
    tabItems() {
      return this.isleft ? this.currentDetailMission.tabsleft.tabs : this.currentDetailMission.tabsright.tabs
    },
    missionSecurity() {
      return this.currentDetailMission.mission.security
    },
    misId() {
      return this.currentDetailMission.mission.misId
    },
    gliderId() {
      return this.currentDetailMission.mission.gliId
    },
    temps() {
      return this.originalFileTransfertConfigs[this.gliderId]?.mod_settings?.EnabledMOD?.['module-FileTransfer']
    },
    runtimeModules() {
      return this.currentDetailMission?.mission?.gliderRuntime?.modules ?? {}
    },
    // Source unique : `gliderRuntime.modules` (peuplé par mod_list initial + chaque
    // success de fetch IRIS module config + WobGliderModConf). Le fallback
    // historique `mod_list` direct est superflu — toutes les sources convergent
    // dans le runtime.
    moduleIrisState() {
      const m = this.runtimeModules
      return {
        AD2CP: m.AD2CP ?? false,
        NextSurfacingDo: m.NextSurfacingDo ?? false,
        SingleWayPoint: m.SingleWayPoint ?? false,
        MissionPlan: m.MissionPlan ?? false,
        SendMail: m.SendMail ?? false,
        FileTransfer: m.FileTransfer ?? false,
        Coriolis: m.Coriolis ?? false,
        // FtpRsync est un combo dérivé — le runtime stocke les deux flags séparés
        // (clés 'FTP' / 'RSync' selon mod_api_id), MenuMenu n'affiche qu'un seul item.
        FtpRsync: !!(m.FTP || m.RSync),
        AIS: m.AIS ?? false,
        QuickControl: m.QuickControl ?? false,
      }
    },
  },
  methods: {
    tabCreated(cmp) {
      return this.tabItems.findIndex(it => it.cmp == cmp) > -1
    },
    tryTranslate(key) {
      const transKey = `Pilot.MissionDetailMenu.${key}`
      const trad = this.$t(transKey)
      return transKey == trad ? key : trad
    },
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.menu-btn {
  width: 100%;
  min-width: 230px;
  border-radius: 8px;
}
hr {
  margin: 0.5em auto;
}
hr:last-child {
  display: none;
}
</style>
